export default __webpack_public_path__ + "static/media/down.e8076aa9.svg";